import { ClientDataType, AnyComparator } from 'modules/queryBuilder/types';
import { AddNew16 } from 'ui/icons/aurora/16px/AddNew16';
import { BUTTON_VARIANTS } from 'ui/button';
import { QueryBuilderSelect } from './QueryBuilderSelect';
import {
  ConditionSingleValueSelectProps,
  ConditionSingleValueSelectWithButtonProps,
} from '../types';
import { QueryBuilderSelectWithButton } from './QueryBuilderSelectWithButton';

export const ConditionSingleValueStringSelect = (
  props: ConditionSingleValueSelectProps<string>,
) => <QueryBuilderSelect {...props} />;

export const ConditionSingleValueNumberSelect = (
  props: ConditionSingleValueSelectProps<number>,
) => <QueryBuilderSelect {...props} />;

export const ConditionSingleValueBooleanSelect = (
  props: ConditionSingleValueSelectProps<boolean>,
) => <QueryBuilderSelect {...props} />;

export const ConditionSingleValueComparatorSelect = (
  props: ConditionSingleValueSelectProps<AnyComparator>,
) => <QueryBuilderSelect {...props} />;

export const SingleValueUserProfileSelect = (props: ConditionSingleValueSelectProps<string>) => (
  <QueryBuilderSelect {...props} variant={BUTTON_VARIANTS.SECONDARY} DefaultIcon={<AddNew16 />} />
);

export const SingleValueEventSelect = ({
  isInRequirement = false,
  ...rest
}: ConditionSingleValueSelectProps<ClientDataType> & { isInRequirement?: boolean }) => (
  <QueryBuilderSelect
    {...rest}
    {...(!isInRequirement && {
      variant: BUTTON_VARIANTS.SECONDARY,
      DefaultIcon: <AddNew16 />,
    })}
  />
);

export const ConditionSingleValueStringSelectWithButton = (
  props: ConditionSingleValueSelectWithButtonProps<string>,
) => <QueryBuilderSelectWithButton {...props} />;
